<ul class="tree-root">
  <ng-container *ngFor="let n of tree">
    <app-orderline-tree-node [node]="n" [states]="states" [autoExpand]="tree.length === 1" (nodeSelected)="nodeSelected($event)" (nodeToggle)="toggleNodeCheck($event)"></app-orderline-tree-node>
  </ng-container>
</ul>
